import { Wrapper, Text, Icon } from './SuccessMessage.style'

interface SuccessMessageProps {
  title: string
  icon?: boolean
}

const SuccessMessage = ({
  title,
  icon = true,
  ...props
}: SuccessMessageProps) => (
  <Wrapper {...props}>
    {icon && <Icon />}
    <Text>{title}</Text>
  </Wrapper>
)

export default SuccessMessage
